import React from 'react';
import { Spinner } from "react-bootstrap";

const LoadingTable = () => {
    return (
        <div className="loading-container">
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );
};

export default LoadingTable;
